import {dynamicImportErrorsRegexs} from 'src/internal/errors/constants/filters';

import type {EventProcessor, Integration} from '@sentry/types';

type AddGlobalEventProcessor = (callback: EventProcessor) => void;

export default class StaticAssetsIntegration implements Integration {
  name = 'StaticAssetsIntegration';

  setupOnce(addGlobalEventProcessor: AddGlobalEventProcessor): void {
    addGlobalEventProcessor((event) => {
      if (!event.sdk?.integrations?.includes(this.name)) {
        return event;
      }

      const firstException = event.exception?.values?.[0];
      const isNativeImportError =
        (firstException?.type === 'Error' ||
          firstException?.type === 'TypeError') &&
        typeof firstException.value === 'string' &&
        dynamicImportErrorsRegexs.some((regex) =>
          regex.test(firstException.value as string),
        );

      return isNativeImportError ? null : event;
    });
  }
}
